const PainelTms = (props) => {

    let { ling, specs, valid, onCritChange2, sh2, onSpecChange2, onSpecBlur2, cparte2 } = {...props};
    
    function validPainel (lim) {
        let x = valid (lim, specs.lims, props.comp, specs.crit, specs.od, ling);
        let s = {...specs};
        s.lims[lim] = x;
        props.setSpecs(s);
    }

    function serv (specs, serv) {
        specs.res = null;
        if (specs.crit !== "Ranking") {
            specs.crit = "Intervalo";
            if (serv === 'pomp') {
                specs.lims = props.varGlob.refLim['pomp'][0];
                specs.crit = "Intervalo T";
            } else {
                specs.lims = props.varGlob.refLim[serv];
            }
        }
        props.setSpecs(specs);
        props.setComp(serv);
    }

    let promptSem = "0 (Seg) a 6 (Dom)   vazio: todos";
    if (ling === 'uk') promptSem = "0 (Mon) to 6 (Sun)   empty: all";
    let promptVeic = "1-72 101-130   vazio: todos";
    if (ling === 'uk') promptVeic = "1-72 101-130   empty: all";
    let promptLin = "A-E Z   vazio: todos";
    if (ling === 'uk') promptLin = "A-E Z   empty: all";
    let prompt = "Disponível Jan2016-Fev2021";
    if (ling === 'uk') prompt = "Jan2016-Feb2021 available";
    

    return ( 
        <div className="paineltms">
            <label style={{paddingTop: "10px"}}>A: (FNZ SOV) --- B: (SMT AER PVZ ISM HSJ)</label><br></br><br></br>
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd">
                            <span style={{float: 'left', verticalAlign: "top"}}>Usando como critério:</span>
                        </td>
                        <td className="bgrd">
                            <input type="radio" id="rank" name="rankint" value="Ranking"
                            onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'tms'))} 
                            defaultChecked={props.specs.crit === 'Ranking'}
                            style={{marginLeft: "40px", verticalAlign: "top"}}></input>
                            Ranking
                        </td>
                        <td className="bgrd" style={{verticalAlign: "top"}}>
                            <input type="radio" id="intervT" name="rankint" value="Intervalo"
                            onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'tms'))}
                            defaultChecked={props.specs.crit === 'Intervalo'}
                            style={{verticalAlign:"top"}}></input>
                            Intervalo
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: "10px"}}> Limites: </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[0]} maxLength="6" size="4" onBlur={() => validPainel(0)} onChange={(e) => props.setSpecs(sh2(0, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[1]} maxLength="6" size="4" onBlur={() => validPainel(1)} onChange={(e) => props.setSpecs(sh2(1, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[2]} maxLength="6" size="3" onBlur={() => validPainel(2)} onChange={(e) => props.setSpecs(sh2(2, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="l1" value={props.specs.lims[3]} maxLength="6" size="3" onBlur={() => validPainel(3)} onChange={(e) => props.setSpecs(sh2(3, e.target.value, {...props.specs}))}></input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="serv">
                <tbody>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Veículos:  </td>
                        <td className="bgrd"><input type="text" id="Veic" value={props.specs.veiculos} placeholder={promptVeic} onChange={(e) => props.setSpecs(onSpecChange2(e, 'veiculos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'veiculos', {...props.specs}))}></input></td>
                        <td className="bgrd"><button style={{fontWeight: 'normal', padding: "1px 13px", backgroundColor: props.specs.ET? "black" : "#F0F0F0", color: props.specs.ET? "white": "black"}} id="ET" onClick={() => props.setSpecs(cparte2('ET', {...props.specs})) }> ET </button></td>
                        <td className="bgrd"><button style={{fontWeight: 'normal', padding: "1px 10px", backgroundColor: props.specs.TT? "black" : "#F0F0F0", color: props.specs.TT? "white": "black"}} id="TT" onClick={() => props.setSpecs(cparte2('TT', {...props.specs})) }> TT </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Linhas:  </td>
                        <td className="bgrd"><input type="text" id="Linh" value={props.specs.linhas} placeholder={promptLin} onChange={(e) => props.setSpecs(onSpecChange2(e, 'linhas', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'linhas', {...props.specs}))}></input></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>DSem:  </td>
                        <td className="bgrd">
                            <input type="text" id="Tipo" value={props.specs.tipo} placeholder={promptSem} onChange={(e) => props.setSpecs(onSpecChange2(e, 'tipo', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'tipo', {...props.specs}))}>
                            </input> </td>
                        <td className="bgrd"><button style={{fontWeight: 'normal', padding: '1px 10px', backgroundColor: props.specs.fer? "black" : "#F0F0F0", color: props.specs.fer? "white": "black"}} id="fer" onClick={() => props.setSpecs(cparte2('fer', {...props.specs})) }> Fer.</button></td>
                        <td className="bgrd"><button style={{fontWeight: 'normal',padding: '1px 6px', backgroundColor: props.specs.nfer? "black" : "#F0F0F0", color: props.specs.nfer? "white": "black"}} id="nfer" onClick={() => props.setSpecs(cparte2('nfer', {...props.specs})) }> Não</button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Anos:  </td>
                        <td className="bgrd" style={{paddingLeft: "px"}}>
                            <input type="text" id="Anos" value={props.specs.anos} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'anos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'anos', {...specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingLeft: "6px"}}>
                            <button type="button" title="Colorir troços em função do número de etapas"
                            onClick={() => serv (specs, "ode") }>
                            OD Et </button></td>
                        <td className="bgrd">
                            <button type="button" style={{width: "40px"}}title="Colorir estações em função do número de cartões diferentes usados"
                            onClick={() => serv (specs, "cart") }>
                            Cart </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Meses:  </td>
                        <td className="bgrd" stylr={{paddingLeft: "14px"}}>
                            <input type="text" id="Meses" value={props.specs.meses} onChange={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'meses', {...specs}))}></input></td>
                        <td className="bgrd" style={{paddinLeft: "5px"}}>
                            <button type="button" title="Colorir estações em função do número de viagens"
                            onClick={() => {
                                specs.res = null;
                                props.setSpecs(specs);
                                props.setComp("odv");
                            }}>
                            OD Vi </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}>Horas: </td>
                        <td className="bgrd" style={{paddingLeft: "8px"}}>
                            <input type="text" id="Horas" value={props.specs.horas} onChange={(e) => props.setSpecs(onSpecChange2(e, 'horas', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'horas', {...specs}))}></input></td>
                        <td className="bgrd" style={{width: "58px"}}>
                            <button style={{padding: "1px 10px"}} type="button" title="Colorir estações em função do número de validações"
                            onClick={() => serv (specs, "val") }>
                            Valid </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left", paddingBottom: "8px"}}>DMês:  </td>
                        <td className="bgrd" style={{paddingLeft: "6px", paddingBottom: "10px"}}>
                            <input type="text" id="Dmes" value={props.specs.dmes} onChange={(e) => props.setSpecs(onSpecChange2(e, 'dmes', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'dmes', {...specs}))}></input>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: "1px 6px"}} type="button" title="Colorir troços em função da procura e da oferta"
                            onClick={() => serv (specs, "pomp") }>
                            PO </button></td>
                    </tr>                
                </tbody>
            </table>
        </div>
    );
}

export default PainelTms;